import { apiClient } from "@nabble/sdk";

/** A stored brand image (Admin Center → Branding), without its content. */
export interface BrandImageInfo {
  slot: string;
  contentType: string;
  size: number;
  updatedAt: string;
}

export function fetchBrandImages(): Promise<BrandImageInfo[]> {
  return apiClient<BrandImageInfo[]>("/api/admin/branding");
}

/** `data` is the file as base64; the server checks it is a PNG, JPEG or WebP of at most 2 MB. */
export function uploadBrandImage(slot: string, data: string): Promise<void> {
  return apiClient<void>(`/api/admin/branding/${slot}`, { method: "PUT", body: { data } });
}

export function removeBrandImage(slot: string): Promise<void> {
  return apiClient<void>(`/api/admin/branding/${slot}`, { method: "DELETE" });
}
